(function () {
    'use strict';

    run.admin.parts.rackootsShortcuts = function() {
        // Shortcuts
        document.addEventListener('keyup', function(e) {
            if (!e.ctrlKey) {
                // document.getElementById('rackoots_nav').classList.remove('on_top');

                const current_shortcut_tool = document.querySelectorAll('#tool_group__active .tool.shortcut_waiting__current')[0];
                const current_shortcut_rackoot = document.querySelectorAll('#rackoots_nav .rackoot__item.shortcut_waiting__current')[0];

                hideShortcutIndicator();

                if (current_shortcut_tool && typeof current_shortcut_tool !== 'undefined') {
                    current_shortcut_tool.classList.remove('shortcut_waiting__current');
                    const link = current_shortcut_tool.getElementsByClassName('tool__visit')[0];
                    window.open(link.href, 'blank');
                }

                if (current_shortcut_rackoot && typeof current_shortcut_rackoot !== 'undefined') {
                    current_shortcut_rackoot.classList.remove('shortcut_waiting__current');
                    const link = current_shortcut_rackoot.querySelectorAll('a')[0];
                    window.location.href = link.href;
                }
            }
        });

        function shouldIgnoreTile(id)
        {
            if (id == 'btn_add_tile__not_logged' || id == 'btn_new_menu' || id == 'btn_suggest_tile') { return true; }

            return false;
        }

        document.addEventListener('keydown', function(e) {
            if (e.ctrlKey) {
                const isNumber = isFinite(e.key);
                // Use for rackoots
                // if (e.key == 'r' || e.key == 'u' || e.key == 't' || e.key == '-' || e.key == '+') {
                //     return;
                // }

                // document.getElementById('rackoots_nav').classList.add('on_top');

                const viewer = document.getElementById('shortcout_viewer');
                viewer.classList.add('shortcut_display');

                // Tools
                const tools = document.querySelectorAll('#tool_group__active .tool');
                [].forEach.call(tools, function(tool, index) {
                    if (shouldIgnoreTile(tools[index].id)) { return; }
                    tools[index].classList.remove('shortcut_waiting__current');
                    tools[index].classList.add('shortcut_waiting');
                    let badge = tools[index].querySelector('.tool_shortcut_number');
                    if (!badge) {
                        let num = index+1;
                        let badge = document.createElement('span');
                        badge.classList.add('tool_shortcut_number');
                        badge.innerHTML = num;
                        tool.appendChild(badge);
                    }
                });

                if (!isNumber) {
                    return;
                }
                // Rackoots
                /*
                const rackoots = document.querySelectorAll('#rackoots_nav .rackoot__item');
                const letters = ['a','s','d','f','g','h','j','k','l'];
                const count_letters = letters.length;
                [].forEach.call(rackoots, function(tool, index) {
                    if (index < count_letters) {
                        rackoots[index].classList.remove('shortcut_waiting__current');
                        rackoots[index].classList.add('shortcut_waiting');
                        let badge = rackoots[index].querySelector('.rackoot_shortcut_letter');
                        if (!badge) {
                            let badge = document.createElement('span');
                            badge.classList.add('rackoot_shortcut_letter');
                            badge.innerHTML = letters[index];
                            tool.appendChild(badge);
                        }
                    }
                })
                */

                if (e.key != ' ') {
                    e.preventDefault();
                    e.stopPropagation();

                    const num_container = viewer.getElementsByTagName('span')[0];
                    
                    // if (!isNumber && !letters.includes(e.key)) { // Use for rackoots
    
                    if (isNumber) {
                        if (!isFinite(num_container.innerHTML)) { num_container.innerHTML = ''; } // reset
                        num_container.innerHTML = num_container.innerHTML + e.key;
                        const current = num_container.innerHTML;
                        
                        let current_tool_el = tools[current-1];
                        current_tool_el.classList.add('shortcut_waiting__current');
                    // } else {
                        // if (isFinite(num_container.innerHTML)) { num_container.innerHTML = ''; } // reset
                        // num_container.innerHTML = num_container.innerHTML + e.key;
                        // const current = num_container.innerHTML;
                        // const key = getKeyByValue(letters, current);
                        
                        // let current_rackoot_el = rackoots[key];
                        // current_rackoot_el.classList.add('shortcut_waiting__current');
                    }
    
                }
            }
        })

        window.addEventListener('blur', function(e){
            hideShortcutIndicator();
        })

        function hideShortcutIndicator() {
            // Tools and numbers
            const tools = document.querySelectorAll('#tool_group__active .tool');
            [].forEach.call(tools, function(tool, index) {
                if (shouldIgnoreTile(tools[index].id)) { return; }
                tools[index].classList.remove('shortcut_waiting');
            }) 

            const numbers = document.querySelectorAll('#tool_group__active .tool_shortcut_number');
            [].forEach.call(numbers, function(num, index) {
                numbers[index].remove();
            })

            // RAckoots and letters
            const rackoots_items = document.querySelectorAll('#rackoots_nav .rackoot__item');
            [].forEach.call(rackoots_items, function(item, index) {
                rackoots_items[index].classList.remove('shortcut_waiting');
            }) 

            const letters = document.querySelectorAll('#rackoots_nav .rackoot_shortcut_letter');
            [].forEach.call(letters, function(num, index) {
                letters[index].remove();
            })

            // Viewer
            const viewer = document.getElementById('shortcout_viewer');
            if (viewer !== null) {
                viewer.classList.remove('shortcut_display');
                const num_container = viewer.getElementsByTagName('span')[0];
                num_container.innerHTML = '';
            }
        }
    }
})();